import axiosInstance from "../axiosInstance";

export const POSTSyncArticuloMultiplo = async (idartl, matcod, multip) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_WMS_BASE_URL}/articulos/syncarticulomultiplo`,
      {
        idartl,
        matcod,
        multip,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default POSTSyncArticuloMultiplo;
